/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceConfigurationModel } from '../../models/service-configuration-model';

export interface AnonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params {
  parentOrganizationFhirId: string;
  healthCareServiceFhirId: string;
  locationFhirId: string;
  specialityFhirId: string;
}

export function anonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet(http: HttpClient, rootUrl: string, params: AnonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<ServiceConfigurationModel>> {
  const rb = new RequestBuilder(rootUrl, anonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('parentOrganizationFhirId', params.parentOrganizationFhirId, {});
    rb.path('healthCareServiceFhirId', params.healthCareServiceFhirId, {});
    rb.path('locationFhirId', params.locationFhirId, {});
    rb.path('specialityFhirId', params.specialityFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<ServiceConfigurationModel>;
    })
  );
}

anonymousServiceConfigurationExtendedHoursOfOperationParentOrganizationFhirIdHealthCareServiceFhirIdLocationFhirIdSpecialityFhirIdGet.PATH = '/Anonymous/ServiceConfigurationExtendedHoursOfOperation/{parentOrganizationFhirId}/{healthCareServiceFhirId}/{locationFhirId}/{specialityFhirId}';
